module.exports = __webpack_public_path__ + "static/img/rico_star.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/rico_star.jpg
// module id = olTf
// module chunks = 0